import axios from 'axios'
import { CHART_KPIS } from '@/utils/kpiUtils'
import dayjs from 'dayjs'
import { t } from '@/i18n'

/**
 * Before any API call, retrieve the clientID from the evnironmet to set the required X-IBM-Client-Id value
 **/
async function checkCredential(config) {
  if (!config.url.includes('apimanagerconsumercredentials')) {
    if (!window.api_credentials && !window.api_credentials_request) {
      window.api_credentials_request = axios
        .get('/portal/config/apimanagerconsumercredentials.json')
        .then(resp => (window.api_credentials = resp.data))
        .catch(err => console.log('Error fetching credentials ' + err))
    }
    await window.api_credentials_request
    config.headers.common['X-IBM-Client-Id'] = window.api_credentials?.clientId
  }

  return config
}

axios.interceptors.request.use(checkCredential)

// --- TUTORIALS ----

// {
//   guillotine {
//     query(query:"type='org.bestiario.cms:webpage' AND _path LIKE '*/tutoriales*'" first:100 sort:"_manualordervalue DESC") {
//       _path
//       ... on org_bestiario_cms_Webpage {
//         data {
//           text:htmldefinition_ca{
//             processedHtml
//           }
//           title: title_ca
//         }
//       }
//     },
//     folder:query(query: "type='base:folder' AND _path LIKE '*/tutoriales/*'" first:100 sort:"_manualordervalue DESC") {
//       displayName
//       _path
//     }
//   }
// }

// ---- WEBPAGE ----

// const webpageQuery = `{
//   guillotine {
//    query(query: "type='org.bestiario.cms:webpage'") {
//      contentType {name }
//      _name
//      ... on org_bestiario_cms_Webpage {
//       data {
//         text:htmldefinition_ca {
//           processedHtml
//         }
//         title:title_ca
//       }
//     }
//    }
//   }
//  }`

// ---- CARDS ----

// const cardQuery = `{
//   guillotine {
//    query(query: "type='org.bestiario.cms:card'") {
//      contentType {name }
//      _name
//      dataAsJson
//      ... on org_bestiario_cms_Card {
//       data {
//         title:title_ca
//         category:category
//         urlgraphic:urlgraphic
//       }
//     }
//    }
//   }
//  }`

// ---- NEWS ----

// const newsQuery = `{
//   guillotine {
//     query(query: "type='org.bestiario.cms:news'") {
//       contentType {name }
//       _name
//       publish {from to first}
//       ... on org_bestiario_cms_News {
//         data {
// 					text:text_ca {
// 						processedHtml
// 					}
//           title:title_ca
//           urlindicator:urlindicator
//           category:category
//           thumbnail:photo{
//             ... on media_Image {
//               imageUrl(scale:"block(400,300)",type:server)
//             }
//             ... on media_Vector {
//               imageUrl:mediaUrl
//             }
//           }
//           photo{
//             ... on media_Image {
//               imageUrl:mediaUrl
//             }
//             ... on media_Vector {
//               imageUrl:mediaUrl
//             }
//           }
//         }
//       }
//     }
//   }
// }`

// ---- DATASTORIES ----

// const datastoriesQuery = `{
//   guillotine {
//    query(query: "type='org.bestiario.cms:datastory'") {
//      contentType {name }
//      _name
//      publish {from to first}
//      ... on org_bestiario_cms_Datastory {
//       data {
//         photo{
//           ... on media_Image {
//             imageUrl:mediaUrl
//           }
//           ... on media_Vector {
//             imageUrl:mediaUrl
//           }
//         }
//         title:title_ca
//         desc:description_ca {
//           processedHtml
//         }
//         urldatastory:urldatastory
//         typeSelected:type {
//           _selected
//         }
//       }
//     }
//    }
//   }
//  }`

// ---- CALENDAR ----

// const calendarQuery = `{
//   guillotine {
//    query(query: "type='org.bestiario.cms:calendar'") {
//      contentType {name }
//      _name
//      publish {from to first}
//      ... on org_bestiario_cms_Calendar {
//       data {
//         relatedUrl:relatedUrl
//         title:title_ca
//         description:description_ca {
//           processedHtml
//         }
//         period:period
//         newpublication:newpublication
//         delay:delay
//         delayReason:delayreason_ca
//       }
//     }
//    }
//   }
//  }`

function createQueryWithLang(type, lang, limits) {
  let query = null
  if (type === 'tutorial') {
    query =
      `{
      guillotine {
        query(query:"type='org.bestiario.cms:webpage' AND _path LIKE '*/tutoriales*'" first:100 sort:"_manualordervalue DESC") {
          _path
          _name
          ... on org_bestiario_cms_Webpage {
            data {
              text:htmldefinition_` +
      lang +
      `{
                processedHtml
              }
              title: title_` +
      lang +
      `
            }
          }
        },
        folder:query(query: "type='base:folder' AND _path LIKE '*/tutoriales/*'" first:100 sort:"_manualordervalue DESC") {
          displayName
          _path
        }
      }
    }`
  } else if (type === 'links' || type === 'about' || type === 'terms' || type === 'quote') {
    query =
      `{
      guillotine {
       query(query: "type='org.bestiario.cms:webpage' AND _name LIKE '` +
      type +
      `'") {
         contentType {name }
         _name
         ... on org_bestiario_cms_Webpage {
          data {
            text:htmldefinition_` +
      lang +
      `{
              processedHtml
            }
            title: title_` +
      lang +
      `
          }
        }
       }
      }
     }`
  } else if (type === 'webpage') {
    query =
      `{
      guillotine {
       query(query: "type='org.bestiario.cms:webpage'" first:100) {
         contentType {name }
         _name
         ... on org_bestiario_cms_Webpage {
          data {
            text:htmldefinition_` +
      lang +
      `{
              processedHtml
            }
            title: title_` +
      lang +
      `
          }
        }
       }
      }
     }`
  } else if (type === 'card') {
    query =
      `{
      guillotine {
       query(query: "type='org.bestiario.cms:card'" first:100) {
         contentType {name }
         _name
         dataAsJson
         ... on org_bestiario_cms_Card {
          data {
            title:title_` +
      lang +
      `
            category:category
            score:score
            urlgraphic:urlgraphic
          }
        }
       }
      }
     }`
  } else if (type === 'news') {
    query =
      `{
      guillotine {
        query(query: "type='org.bestiario.cms:news'" first:100) {
          contentType {name }
          _name
          _id
          publish {from to first}
          ... on org_bestiario_cms_News {
            data {
              text:text_` +
      lang +
      ` {
                processedHtml
              }
              title:title_` +
      lang +
      `
              urlindicator:urlindicator` +
      (lang === 'ca' ? '' : '_' + lang) +
      `
              textindicator:textindicator` +
      (lang === 'ca' ? '' : '_' + lang) +
      `
              category:category
              score:score
              thumbnail:photo{
                ... on media_Image {
                  imageUrl(scale:"block(400,300)",type:server)
                }
                ... on media_Vector {
                  imageUrl:mediaUrl
                }
              }
              photo{
                ... on media_Image {
                  imageUrl:mediaUrl
                }
                ... on media_Vector {
                  imageUrl:mediaUrl
                }
              }
            }
          }
        }
      }
    }`
  } else if (type === 'datastories') {
    query =
      `{
      guillotine {
       query(query: "type='org.bestiario.cms:datastory'" first:100) {
         contentType {name }
         _name
         publish {from to first}
         ... on org_bestiario_cms_Datastory {
          data {
            photo{
              ... on media_Image {
                imageUrl:mediaUrl
              }
              ... on media_Vector {
                imageUrl:mediaUrl
              }
            }
            score:score
            title:title_` +
      lang +
      `
            desc:description_` +
      lang +
      ` {
              processedHtml
            }
            urldatastory:urldatastory` +
      (lang === 'ca' ? '' : '_' + lang) +
      `
            typeSelected:type {
              _selected
            }
          }
        }
       }
      }
     }`
  } else if (type === 'calendar') {
    query =
      `{
      guillotine {
       query(query: "type='org.bestiario.cms:calendar' AND data.period>='` +
      limits +
      `'" first:150 sort:"data.period ASC") {
         contentType {name }
         _name
         publish {from to first}
         ... on org_bestiario_cms_Calendar {
          data {
            hour:hour
            title:title_` +
      lang +
      `
            relatedUrl:relatedUrl` +
      (lang === 'ca' ? '' : '_' + lang) +
      `
            description:description_` +
      lang +
      ` {
              processedHtml
            }
            period:period
            newpublication:newpublication
            delay:delay
            type:type 
            delayReason:delayreason_` +
      lang +
      `
          }
        }
       }
      }
     }`
  } else if (type === 'report') {
    if (limits) {
      query =
        `{
      guillotine {
        query(query: "type='org.bestiario.cms:report' AND _name LIKE '` +
        limits +
        `'") {
         contentType {name }
         _name
         publish {from to first}
          ... on org_bestiario_cms_Report {
            data {
              language:language{_selected}
              title:title
              id:id
              description:description {
                  processedHtml
              }
              index:index{
                processedHtml
              }
            }
          }
          pageAsJson
          components {
            path
            text {
              value {
                processedHtml
              }
            }
          }
          _references{
            _id
            attachments{
              attachmentUrl
            }
          }
       }
      }
     }`
    } else {
      query = `{
        guillotine {
          query(query: "type='org.bestiario.cms:report'") {
            contentType {name }
            _name
            publish {from to first}
            pageAsJson
          }
        }
      }`
    }
  }
  return query
}

export function getCMSCards(lang) {
  let langList = ['ca', 'es', 'en']
  return axios
    .post('/services/backend/rest/cmsdata', {
      query: createQueryWithLang('card', lang),
      variables: {
        /* se pueden meter varibles!!*/
      },
    })
    .then(r => r.data.data.guillotine.query)
    .then(data => {
      return data.map(d => {
        let urlLang = langList.filter(el => d.data.urlgraphic.split('/').indexOf(el) !== -1)[0]
        return {
          id: d._id,
          title: d.dataAsJson['title_' + lang],
          kpis: Object.keys(d.dataAsJson).filter(
            k => CHART_KPIS.indexOf(k) >= 0 && d.dataAsJson[k] === 'true'
          ),
          category: d.data.category.map(el => el.split('|')[langList.indexOf(lang)]),
          score: d.data.score,
          url: d.data.urlgraphic.slice(
            d.data.urlgraphic.indexOf('/' + urlLang + '/'),
            d.data.urlgraphic.length - 1
          ),
        }
      })
    })
    .catch(function () {
      // if (err.response.status === 429 || err.response.httpCode === '429') {
      //   let currentLanguage = window.location.pathname
      //     .split('/')
      //     .find(el => el === 'ca' || el === 'es' || el === 'en')
      //   window.location.assign('/' + currentLanguage + '/page-429')
      // } else {
      return {
        code: 500,
      }
      // }
    })
}

export function getCMSNews(lang) {
  let langList = ['ca', 'es', 'en']
  return axios
    .post('/services/backend/rest/cmsdata', {
      query: createQueryWithLang('news', lang),
      variables: {
        /* se pueden meter varibles!!*/
      },
    })
    .then(r => r.data.data.guillotine.query)
    .then(data => {
      return data.map(d => ({
        id: d._id,
        title: d.data.title,
        desc: d.data.text.processedHtml || 'No description found',
        thumbnail: d.data.thumbnail?.imageUrl,
        score: d.data.score,
        photo: d.data.photo?.imageUrl,
        date: dayjs(new Date(d.publish.from)).format('MMMM YYYY') || 'unkown',
        url: d.data.urlindicator,
        textindicator: d.data.textindicator,
        category:
          typeof d.data.category === 'string'
            ? [d.data.category.split('|')[langList.indexOf(lang)]]
            : d.data.category.map(el => el.split('|')[langList.indexOf(lang)]),
      }))
    })
    .catch(function () {
      // if (err.response.status === 429 || err.response.httpCode === '429') {
      //   let currentLanguage = window.location.pathname
      //     .split('/')
      //     .find(el => el === 'ca' || el === 'es' || el === 'en')
      //   window.location.assign('/' + currentLanguage + '/page-429')
      // } else {
      return {
        code: 500,
      }
      // }
    })
}

export function getCMSDatastories(lang) {
  return axios
    .post('/services/backend/rest/cmsdata', {
      query: createQueryWithLang('datastories', lang),
      variables: {
        /* se pueden meter varibles!!*/
      },
    })
    .then(r => r.data.data.guillotine.query)
    .then(data => {
      return data.map(d => ({
        id: d._id,
        title: d.data.title,
        desc: d.data.desc.processedHtml || 'No description found',
        date: dayjs(new Date(d.publish.from)).format('MMMM YYYY') || 'unkown',
        score: d.data.score,
        imgUrl: d.data.photo?.imageUrl,
        url: d.data.urldatastory,
        typeSelected: d.data.typeSelected._selected,
      }))
    })
    .catch(function () {
      // if (err.response.status === 429 || err.response.httpCode === '429') {
      //   let currentLanguage = window.location.pathname
      //     .split('/')
      //     .find(el => el === 'ca' || el === 'es' || el === 'en')
      //   window.location.assign('/' + currentLanguage + '/page-429')
      // } else {
      return {
        code: 500,
      }
      // }
    })
}

async function getResource(reSrc) {
  let response = await axios
    .get(reSrc, {
      responseType: 'blob',
    })
    .then(res => {
      return res.data
    })
    .then(blob => {
      const objUrl = URL.createObjectURL(blob)
      return objUrl
    })
  return await response
}

async function addResourceToComputed(reSrc) {
  return [reSrc, await getResource(reSrc)]
}

async function getComputedPage(page, comp, refs) {
  let re = refs
  let computedPage = ''
  let height = 320
  let width = '100%'
  let promis = []
  page.regions.main.components.forEach(com => {
    if (com.type === 'text') {
      let z = comp.find(el => el.path === com.path)
      computedPage += z.text.value.processedHtml
    } else if (com.type === 'layout') {
      computedPage += '<div class="row">'
      Object.keys(com.regions).forEach((el, i) => {
        computedPage +=
          '<div class="' + el + '" style="width: ' + com.config.layoutConf.split('-')[i] + '%">'
        com.regions[el].components.forEach(x => {
          if (x.config?.height) {
            height =
              x.config.height === 'one'
                ? 320
                : x.config.height === 'two'
                ? 480
                : x.config.height === 'double'
                ? 640
                : 320
            if (
              x.config.height === 'custom' &&
              x.config.customHeigth !== '' &&
              x.config.customHeigth !== undefined
            ) {
              height = x.config.customHeigth
            }
          } else height = 320
          if (x.config && x.config?.width) {
            width = x.config.width
          } else width = '100%'
          if (x.type === 'text') {
            let z2 = comp.find(el => el.path === x.path)
            computedPage += z2.text.value.processedHtml
          } else if (x.type === 'part') {
            if (x.descriptor === 'org.bestiario.cms:iframeChart') {
              let iframeSrc = x.config.src
              computedPage +=
                '<div class="iframe-wrapper"><iframe src="' +
                iframeSrc +
                '" width="' +
                width +
                '" height="' +
                height +
                '"></iframe></div>'
              if (x.config.date) {
                let d = dayjs(x.config.date).format('DD/MM/YYYY')
                computedPage += '<span>' + t('update_date') + ': ' + d + '</span>'
              }
            } else if (x.descriptor === 'org.bestiario.cms:HTMLChart') {
              let reSrc = re
                .find(el => el._id === x.config.file)
                .attachments[0].attachmentUrl.replace(
                  '/services/cmsportaldades/ajbcn-repo/_graphql',
                  '/services/backend/rest/cmsdata'
                )
              computedPage +=
                '<div class="iframe-wrapper"><iframe src="' +
                reSrc +
                '" width="' +
                width +
                '" height="' +
                height +
                '"></iframe></div>'
              if (x.config.date) {
                let d = dayjs(x.config.date).format('DD/MM/YYYY')
                computedPage += '<span>' + t('update_date') + ': ' + d + '</span>'
              }
              promis.push(addResourceToComputed(reSrc))
            }
          }
        })
        computedPage += '</div>'
      })
      computedPage += '</div>'
    } else if (com.type === 'part') {
      if (com.config && com.config?.height) {
        height =
          com.config.height === 'one'
            ? 320
            : com.config.height === 'two'
            ? 480
            : com.config.height === 'double'
            ? 640
            : 320
        if (
          com.config.height === 'custom' &&
          com.config.customHeigth !== '' &&
          com.config.customHeigth !== undefined
        ) {
          height = com.config.customHeigth
        }
      } else height = 320
      if (com.config && com.config?.width) {
        width = com.config.width
      } else width = '100%'
      if (com.descriptor === 'org.bestiario.cms:iframeChart') {
        let iframeSrc = com.config.src
        computedPage +=
          '<div class="iframe-wrapper"><iframe src="' +
          iframeSrc +
          '" width="' +
          width +
          '" height="' +
          height +
          '"></iframe></div>'
        if (com.config.date) {
          let d = dayjs(com.config.date).format('DD/MM/YYYY')
          computedPage += '<span>' + t('update_date') + ': ' + d + '</span>'
        }
      } else if (com.descriptor === 'org.bestiario.cms:HTMLChart') {
        let reSrc = re
          .find(el => el._id === com.config.file)
          .attachments[0].attachmentUrl.replace(
            '/services/cmsportaldades/ajbcn-repo/_graphql',
            '/services/backend/rest/cmsdata'
          )
        computedPage +=
          '<div class="iframe-wrapper"><iframe src="' +
          reSrc +
          '" width="' +
          width +
          '" height="' +
          height +
          '"></iframe></div>'
        if (com.config.date) {
          let d = dayjs(com.config.date).format('DD/MM/YYYY')
          computedPage += '<span>' + t('update_date') + ': ' + d + '</span>'
        }
        promis.push(addResourceToComputed(reSrc))
      }
    }
  })
  await Promise.all(promis).then(result => {
    result.forEach(el => {
      computedPage = computedPage.replace(el[0], el[1])
    })
  })
  return computedPage
}

function convertToNestedListObject(element) {
  const result = []
  const child = element.children
  child.forEach(x => {
    x.children.forEach(x2 => {
      if (x2.tagName === 'UL') {
        x2.children.forEach(x3 => {
          x3.children.forEach(x4 => {
            //--
            if (x4.tagName === 'UL') {
              x4.children.forEach(x5 => {
                x5.children.forEach(x6 => {
                  let base = result[result.length - 1].subthemes
                  base[base.length - 1].subthemes.push({
                    name: x6.text,
                    link: x6.href,
                    subthemes: [],
                  })
                })
              })
            } else {
              result[result.length - 1].subthemes.push({
                name: x4.text,
                link: x4.href,
                subthemes: [],
              })
            }
            //--
          })
        })
      } else {
        result.push({
          name: x2.text,
          link: x2.href,
          subthemes: [],
        })
      }
    })
  })
  return result
}

function getParsedIndex(ind) {
  if (!ind) return undefined
  else {
    let index = []

    // let regexLinks = /<a href="([^>]*)">([^<]*)<\/a>/g
    // let links = [...ind.matchAll(regexLinks)]

    var parser = new DOMParser()
    var doc = parser.parseFromString(ind, 'text/html')

    const ulElement = doc.querySelector('ul')
    if (ulElement) {
      index = convertToNestedListObject(ulElement)
    }

    return index
  }
}

async function getCompPage(data) {
  let x = await getComputedPage(data[0].pageAsJson, data[0].components, data[0]._references)
  return [
    {
      id: data[0]._name,
      cmsId: data[0].data.id,
      language: data[0].data.language._selected,
      title: data[0].data.title,
      description: data[0].data.description.processedHtml || 'No description found',
      index: data[0].data.index.processedHtml || 'No index found',
      indexArr: getParsedIndex(data[0].data.index.processedHtml) || 'No index found',
      htmldefinition: x,
    },
  ]
}

export function getCMSReport(lang, id) {
  return axios
    .post('/services/backend/rest/cmsdata', {
      query: createQueryWithLang('report', lang, id),
      variables: {
        /* se pueden meter varibles!!*/
      },
    })
    .then(r => r.data.data.guillotine.query)
    .then(data => {
      if (data.length !== 0) {
        return getCompPage(data).then(re => {
          if (re[0].language !== lang) {
            return updateCMSReportWithLang(lang, re[0].cmsId)
          } else return re
        })
      } else return { code: 500 }
    })
    .catch(function () {
      // if (err.response.status === 429 || err.response.httpCode === '429') {
      //   let currentLanguage = window.location.pathname
      //     .split('/')
      //     .find(el => el === 'ca' || el === 'es' || el === 'en')
      //   window.location.assign('/' + currentLanguage + '/page-429')
      // } else {
      return {
        code: 500,
      }
      // }
    })
}

export function updateCMSReportWithLang(lang, id) {
  return axios
    .post('/services/backend/rest/cmsdata', {
      query:
        `{
        guillotine {
          query(query: "type='org.bestiario.cms:report' AND data.id LIKE '` +
        id +
        `' AND data.language._selected LIKE '` +
        lang +
        `'") {
           contentType {name }
           _name
           publish {from to first}
            ... on org_bestiario_cms_Report {
              data {
                language:language{_selected}
                title:title
                id:id
                description:description {
                    processedHtml
                }
                index:index{
                  processedHtml
                }
              }
            }
            pageAsJson
            components {
              path
              text {
                value {
                  processedHtml
                }
              }
            }
            _references{
              _id
              attachments{
                attachmentUrl
              }
            }
         }
        }
       }`,
      variables: {
        /* se pueden meter varibles!!*/
      },
    })
    .then(r => r.data.data.guillotine.query)
    .then(data => {
      if (data.length !== 0) {
        getCompPage(data).then(re => {
          window.location.assign('/' + lang + '/report/' + re[0].id)
        })
      } else return { code: 404 }
    })
    .catch(function (err) {
      if (err.response.status === 429 || err.response.httpCode === '429') {
        let currentLanguage = window.location.pathname
          .split('/')
          .find(el => el === 'ca' || el === 'es' || el === 'en')
        window.location.assign('/' + currentLanguage + '/page-429')
      } else {
        return {
          code: 500,
        }
      }
    })
}

export function getCMSCalendar(lang, limits) {
  //let langList = ['ca', 'es', 'en']
  let objSources = {
    DOCS: ['documents', 'documentos', 'documents'],
    MAPS: ['mapes', 'mapas', 'maps'],
    SURVEY: ['enquestes', 'encuestas', 'surveys'],
    MICRODATA: ['microdades', 'microdatos', 'microdata'],
    STATISTICS: ['estadístiques', 'estadísticas', 'statistics'],
    DATASTORIES: ['datastories', 'datastories', 'datastories'],
    COMUNICATION: ['notificació', 'notificación', 'notification'],
  }
  return axios
    .post('/services/backend/rest/cmsdata', {
      query: createQueryWithLang('calendar', lang, limits),
      variables: {
        /* se pueden meter varibles!!*/
      },
    })
    .then(r => r.data.data.guillotine.query)
    .then(data => {
      return data.map(d => {
        let sourceFound = false
        if (d.data.type) {
          let src = d.data.type.split('|')[0]
          Object.keys(objSources).forEach(el => {
            if (!sourceFound) {
              if (objSources[el].indexOf(src) !== -1) sourceFound = el
            }
          })
        }

        return {
          id: d._id,
          title: d.data.title,
          subtitle: d.data.description.processedHtml,
          dates: new Date(d.data.period),
          hour: (d.data.hour && d.data.hour.slice(0, 5)) || null,
          source: sourceFound ? sourceFound : 'unknown',
          publishDate: d.publish.from || 'unkown',
          new: d.data.newpublication,
          late: d.data.delay,
          delayReason: d.data.delayReason,
          relatedUrl: d.data.relatedUrl || null,
        }
      })
    })
    .catch(function () {
      // if (err.response.status === 429 || err.response.httpCode === '429') {
      //   let currentLanguage = window.location.pathname
      //     .split('/')
      //     .find(el => el === 'ca' || el === 'es' || el === 'en')
      //   window.location.assign('/' + currentLanguage + '/page-429')
      // } else {
      return {
        code: 500,
      }
      // }
    })
}

//type could be links, about or terms
export function getCMSWebpages(lang, type) {
  return axios
    .post('/services/backend/rest/cmsdata', {
      query: createQueryWithLang(type ? type : 'webpage', lang),
      variables: {
        /* se pueden meter varibles!!*/
      },
    })
    .then(r => r.data.data.guillotine.query)
    .then(data => {
      let mappedData = data.map(d => {
        return {
          name: d._name,
          title: d.data.title,
          htmldefinition: d.data.text.processedHtml,
        }
      })
      return mappedData
    })
    .catch(function (err) {
      if (err.response.status === 429 || err.response.httpCode === '429') {
        let currentLanguage = window.location.pathname
          .split('/')
          .find(el => el === 'ca' || el === 'es' || el === 'en')
        window.location.assign('/' + currentLanguage + '/page-429')
      } else {
        return {
          code: 500,
        }
      }
    })
}

export function getCMSComunications() {
  return axios
    .post('/services/backend/rest/cmsdata', {
      query: `{
        guillotine {
          query(query: "type='org.bestiario.cms:comunication'") {
            contentType {name }
            _name
            publish {from to first}
            ... on org_bestiario_cms_Comunication {
            data {
              title_ca: title_ca
              title_es: title_es
              title_en: title_en
            }
            }
        }
	}
}`,
      variables: {
        /* se pueden meter varibles!!*/
      },
    })
    .then(r => r.data.data.guillotine.query)
    .then(data => {
      let mappedData = data.map(d => {
        return {
          name: d._name,
          title_ca: d.data.title_ca,
          title_es: d.data.title_es,
          title_en: d.data.title_en,
        }
      })
      return mappedData
    })
    .catch(function () {
      return {
        code: 500,
      }
    })
}

export function getCMSTutorials(lang) {
  let langId = lang === 'ca' ? 0 : lang === 'es' ? 1 : 2
  return axios
    .post('/services/backend/rest/cmsdata', {
      query: createQueryWithLang('tutorial', lang),
      variables: {
        /* se pueden meter varibles!!*/
      },
    })
    .then(r => {
      return r.data.data.guillotine
    })
    .then(data => {
      let mappedData = data.query.map(d => {
        return {
          title: d.data.title,
          name: d._name,
          htmldefinition: d.data.text.processedHtml,
          path: d._path,
        }
      })
      let arrTuto = []
      data.folder.forEach(el => {
        arrTuto.push({
          name: el.displayName.split('||')[langId],
          path: el._path,
          options: mappedData.filter(x => x.path.indexOf(el._path) !== -1),
        })
      })
      return arrTuto
    })
    .catch(function (err) {
      if (err.response.status === 429 || err.response.httpCode === '429') {
        let currentLanguage = window.location.pathname
          .split('/')
          .find(el => el === 'ca' || el === 'es' || el === 'en')
        window.location.assign('/' + currentLanguage + '/page-429')
      } else {
        return {
          code: 500,
        }
      }
    })
}

// Get Resource blob from the cms
export function getCmsResourceBlob(src) {
  if (src) {
    return axios
      .get(
        src.replace(
          '/services/cmsportaldades/ajbcn-repo/_graphql',
          '/services/backend/rest/cmsdata'
        ),
        {
          responseType: 'blob',
        }
      )
      .then(res => res.data)
      .catch(function (err) {
        if (err.response.status === 429 || err.response.httpCode === '429') {
          return {
            code: 429,
          }
        } else {
          return {
            code: 500,
          }
        }
      })
  }
}

// export function updateCmsResourceBlob(src, frag, i) {
//   if (src) {
//     return axios
//       .get(
//         src.replace(
//           '/services/cmsportaldades/ajbcn-repo/_graphql',
//           '/services/backend/rest/cmsdata'
//         ),
//         {
//           responseType: 'blob',
//         }
//       )
//       .then(res => res.data)
//       .catch(function (err) {
//         if (err.response.status === 429 || err.response.httpCode === '429') {
//         }
//       })
//       .then(blob => {
//         const objUrl = URL.createObjectURL(blob)
//         frag[i].src = objUrl
//         return objUrl
//       })
//       .then(objUrl => {
//         URL.revokeObjectURL(objUrl)
//       })
//   }
// }

export function vCmsHtml(ele, binding) {
  let regexRmv = /<\/?editor-macro[^>]*>/g
  let val = binding.value
  if (typeof val === 'string') {
    val = val.replaceAll(regexRmv, '')
    val = val.replaceAll('&lt;', '<')
    val = val.replaceAll('&gt;', '>')
  }
  let frag = document.createRange().createContextualFragment(val)
  let filfrag = frag.querySelectorAll('img[src^="/services/cmsportaldades/ajbcn-repo/_graphql"]')

  filfrag.forEach(el => {
    let src = el.getAttribute('src')
    if (src) {
      el.setAttribute('src', '/blank.png')
      el.setAttribute('loading', 'lazy')
      //updateCmsResourceBlob(src, filfrag, i)
      getCmsResourceBlob(src).then(blob => {
        if (blob.code && blob.code === 429) {
          el.src = '/Img429.jpg'
        } else {
          const objUrl = URL.createObjectURL(blob)
          el.src = objUrl
          return objUrl
        }
      })
      // .then(objUrl => {
      //   URL.revokeObjectURL(objUrl)
      // })
    }
    // http://probablyprogramming.com/2009/03/15/the-tiniest-gif-ever
    // el.src = 'data:image/gif;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs%3D'
  })
  ele.replaceChildren(frag)
}

export function getCMSCoverImg() {
  return axios
    .post('/services/backend/rest/cmsdata', {
      query: `{
        guillotine {
          query(query: "_path LIKE '*/ImgCover/*'" first:1 sort:"_manualordervalue DESC") {
            attachments{
              attachmentUrl
            }
	        }
        }
      }`,
    })
    .then(r => r.data.data.guillotine.query)
    .then(data => {
      console.log(data[0].attachments[0].attachmentUrl)
      return getCmsResourceBlob(data[0].attachments[0].attachmentUrl).then(blob => {
        const objUrl = URL.createObjectURL(blob)
        return objUrl
      })
    })
    .catch(function () {
      // if (err.response.status === 429 || err.response.httpCode === '429') {
      //   let currentLanguage = window.location.pathname
      //     .split('/')
      //     .find(el => el === 'ca' || el === 'es' || el === 'en')
      //   window.location.assign('/' + currentLanguage + '/page-429')
      // } else {
      return {
        code: 500,
      }
      // }
    })
}
